module.exports = require('lodash').memoize